module.exports = __webpack_public_path__ + "media/jungle_sound.ca9ac561.mp3";